export default __webpack_public_path__ + "static/media/movilbeam1.14ca3c81.png";